import { useEffect, useState } from 'react';
import Translator from '../../../classes/Translator/Translator';

const InfoQuestionsLogic = (props) => {
    const { translator } = Translator();

  const { type } = props;
  const [text, setText] = useState([]);
  const [urls, setUrls] = useState([]);
  const [values, setValues] = useState({
    ...props,
    questionType: 'containerCard',
  });

  useEffect(() => {
    if (type === 'reverse') {
      setValues({ ...values, questionType: 'containerCardReverse' });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (props) {
      setText(props);
      setUrls(props.urls)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return {
    values,
    text,
    urls,
    translator,

  };
};

export default InfoQuestionsLogic;
